export default "__VITE_ASSET__nM4OCaHQ__"